module.exports = __webpack_public_path__ + "img/ikone-background.cb655ac8.jpg";